import * as t from 'io-ts';

import { DmbDateString } from '@dmb/core';

export const NewsC = t.type({
  id: t.number,
  title: t.string,
  teaser: t.string,
  content: t.string,
  publishDate: DmbDateString,
  requiresConfirmation: t.boolean,
});
export type News = t.TypeOf<typeof NewsC>;
